"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navReady = exports.setupNav = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * Will correct setup the header as early as possible regardless of timing
 * @param  {Function} observerFn A function containing all of the observer methods to customize the header
 * @param  {Function} configFn   A function containing all of the config changes before the header is rendered
 */
const setupNav = (observerFn, configFn) => {
    if (window_or_global_1.default._epicGamesNavObserverCreated) {
        if (observerFn && typeof observerFn === 'function') {
            observerFn();
            /**
             * Example:
             * () => {
             *     root._epicGamesNavObserver.set('isLoggedIn', isLoggedIn);
             * }
             */
        }
    }
    else if (!window_or_global_1.default._egNavAfterConfigSetCalled) {
        let prevSet;
        if (window_or_global_1.default._egNavAfterConfigSet && typeof window_or_global_1.default._egNavAfterConfigSet === 'function') {
            prevSet = window_or_global_1.default._egNavAfterConfigSet;
        }
        window_or_global_1.default._egNavAfterConfigSet = function () {
            if (configFn && typeof configFn === 'function') {
                configFn();
                /**
                 * Example:
                 * () => {
                 *     root._epicGamesNav.isLoggedIn = isLoggedIn;
                 * }
                 */
            }
            if (prevSet)
                prevSet.apply(this);
        };
    }
    else {
        //This almost certainly will never occur... but just in case recheck
        setTimeout(() => {
            setupNav(observerFn, configFn);
        }, 250);
    }
};
exports.setupNav = setupNav;
const navReady = callbackFn => {
    let prevReady;
    if (window_or_global_1.default._egNavReadyCallback && typeof window_or_global_1.default._egNavReadyCallback === 'function') {
        prevReady = window_or_global_1.default._egNavReadyCallback;
    }
    window_or_global_1.default._egNavReadyCallback = function () {
        if (callbackFn && typeof callbackFn === 'function') {
            callbackFn();
        }
        if (prevReady)
            prevReady.apply(this);
    };
};
exports.navReady = navReady;
//# sourceMappingURL=header.js.map